import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackScheduleReminderWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackScheduleReminderWishList = (
    parameters: TrackScheduleReminderWishListParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "schedule_reminder_wishlist", ...parameters }, options);
};

export default trackScheduleReminderWishList;
